/* Home illustration only. CSS owns the timeline; JS manages visibility and pause. */
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-hero-moment]').forEach((card) => {
      if (card.dataset.motion) return;
      const button = card.querySelector('[data-hero-pause]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let paused = false;
      const update = () => {
        card.dataset.motion = visible && !paused && !document.hidden && !reduced.matches ? 'running' : 'paused';
        button.hidden = reduced.matches;
        button.textContent = paused ? 'Resume' : 'Pause';
      };
      if (!('IntersectionObserver' in window)) return; // Finished static fallback.
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        update();
      });
      button.addEventListener('click', () => { paused = !paused; update(); });
      reduced.addEventListener('change', update);
      document.addEventListener('visibilitychange', update);
      update();
      observer.observe(card);
      // Shopify can replace the section in the editor without a page navigation.
      const unload = (event) => {
        if (!event.target.contains(card)) return;
        observer.disconnect();
        reduced.removeEventListener('change', update);
        document.removeEventListener('visibilitychange', update);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
